import apiUrl from '../../../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, MultiSelect } from 'vue-search-select';
import CreateClientContract from './../createContracts';
import Pagination from './../../../../../../shared/components/pagination';
import CustomExpandableTable from './../../../../../../shared/components/customExpandableTable';
import ClientService from '../../../../../services/clientmanagement.service';
import MasterService from './../../../../../../masterdata/services/masterdata.service';
import ContractTemplateView from './../../../../../../masterdata/views/contracttemplate/contracttemplateview';
import CONSTANT from './../../../../../../shared/constants/constant';
import Util from './../../../../../../shared/util/util';

export default {
  name: 'contractListing',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    CreateClientContract,
    CustomExpandableTable,
    CONSTANT,
    ContractTemplateView
  },
  props: ['clientData'],
  data: function() {
    return {
      type: 'CLIENT_CONTRACT',
      createContracts: false,
      isLoading: false,
      showCreateContractsFlag: false,
      contractid: '',
      contractidSearch: '',
      clientstatus: '',
      clientId: '',
      clientShortName: '',
      tableColumn: ['Contract ID', 'Contract Name', 'Company Short/Display Name', 'Start Date', 'End Date','Created By','Created Date','Last Modified By','Last Modified Date','Status ', 'Action'],
      innerTableColumn: [],
      tableItems: [],
      currentPage: 1,
      totalPage: 0,
      totalCount: 0,
      pageLimit: CONSTANT.PER_PAGE_DATA,
      contractTemplateList: [],
      selectedContractObj: '',
      createTemplatesFlag: false,
      selectedEditRow: [],
      offset:0,
      clientbusinessaccountid:''
    }
  },
  computed: {

  },
  mounted() {
    if (this.clientData && this.clientData.ClientBusinessAccountId) {
      this.clientbusinessaccountid = this.clientData.ClientBusinessAccountId;
      this.clientShortName = this.clientData.ClientShortName;
      this.getClientContractList();
      this.getContractMasterTemplateList();
    }
  },
  methods: {
    showCreateContract() {
      if (this.clientData && this.clientData.ClientSystemID=="") {
        this.$alert("Please save client details first.", "", "error");
      } else {
        this.selectedContractObj = [];
        this.showCreateContractsFlag = true;
      }
    },
    callParent() {
      this.showCreateContractsFlag = false;
      this.getClientContractList();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit;
      this.getClientContractList();
    },
    searchContract() {
      this.currentPage = 1;
      this.offset = 0;
      this.contractidSearch = this.contractid;
      this.getClientContractList();
    },
    resetContract() {
      this.currentPage = 1;
      this.offset = 0;
      this.contractid = "";
      this.contractidSearch = "";
      this.getClientContractList();
    },
    async getClientContractList() {
      this.isLoading = true;
      try {
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
          "clientbusinessaccountid": this.clientbusinessaccountid
        }

        if (this.contractidSearch != '') {
          inputPayload.contractid = this.contractidSearch.trim();
        }

        let result = await ClientService.getClientContractList(inputPayload);
        this.tableArr = result.data.data.rows;
        this.isLoading = false;
        this.totalCount = result.data.data.count;
       
        if (this.totalCount > 0) {
          this.tableArr = result.data.data.rows;
          this.tableItems = result.data.data.rows.map((el) => {
            return {
              'id': el.id,
              'Contract ID': el.contractidlabel,
              'Client Business Account ID':el.clientbusinessaccountid,
              'Contract Name': el.contractname,
              'Company Short/Display Name': el.clientshortname,
              'Contract Status': CONSTANT.CONTRACT_STATUS[el.contractstatus],
              'Status ': el.status == 1 ? 'Active':'Inactive',
              'Start Date': el.contracteffectivedatefrom,
              'End Date': el.contracteffectivedateto,
              'Created By':el.createdby,
              'Created Date': Util.displayDateTimeFormat(el.createddate),
              'Last Modified By':el.lastmodifiedby,
              'Last Modified Date':Util.displayDateTimeFormat(el.lastmodifieddate),
              'uom': el.uom,
              'Action': el.contractstatus
            }
          })
        } else {
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
      } catch (err) {
        this.isLoading = false;
        console.log(err);
      }
    },
    getCustomTableEvent(event) {
      if (event.actionType == "active") {
        this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
          this.activeAction(event);
        }).catch((err) => {
          console.log(err)
        });
      } else if (event.actionType == "inactive") {
        this.$confirm("Are you sure to make Active/Inactive?", "", "question").then(() => {
          this.activeAction(event);
        }).catch((err) => {
          console.log(err)
        })
      }
      if (event.actionType == "edit") {
        let selectedContractObj = this.tableArr.filter(function(Items) {
          return Items.id == event.id;
        });
        this.selectedContractObj = selectedContractObj[0];
        this.showCreateContractsFlag = true;
      } else if (event.actionType == "view") {
        let selectedViewRow = this.tableItems.filter(function(Items) {
          return Items.id == event.id;
        });
        selectedViewRow[0].view = true;
        this.selectedEditRow = {
          id: selectedViewRow[0].id,
          clientID: selectedViewRow[0]['Client System ID'],
          contractID: selectedViewRow[0]['Contract ID'],
          uom: selectedViewRow[0]['uom'],
          status: selectedViewRow[0].Status,
          view: selectedViewRow[0].view,
        }
        this.selectedEditRow.ComponentName = CONSTANT.CLIENT_CONTRACT_TEMPLATE
        this.createTemplatesFlag = true;
      }
    },
    async getContractMasterTemplateList() {
      try {
        let inputPayload = {};
        let result = await MasterService.getContractListingForDropDown(inputPayload);
        let contracttemplatelist = result.data.data.rows;
        for (var i = 0; i < contracttemplatelist.length; i++) {
          this.contractTemplateList.push({
            'id': contracttemplatelist[i].id,
            'label': contracttemplatelist[i].contracttemplatename
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    async activeAction(data){
			try {
  			this.isLoading = true;
  			var item = this.tableArr.find(item => item.id === data.id);
  			var isactivestatus = item.status == 0 ? 1 : 0
  			let inputPayload = {
  					"id": data.id,
  					"type": this.type,
  					"status": isactivestatus
  				}
  			let result = await MasterService.changeStatus(inputPayload)
  			if(result.data.code == 200){
  				if(result.data.data[0].status == 0){
  				  this.$alert("Contract Activated Successfully!!", "", "success");
    			}else{
    				this.$alert("Contract Inactivated Successfully!!", "", "success");
    			}
  			  this.getClientContractList();
  			 }
			} catch(err){
				console.log(err);
        this.isLoading = false;
			}
		},
  }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/client/addclient/contracts/contractListing/contractListing.component.js